import { createContext } from 'react';
import { Screens } from './ChatPanel';

export default createContext<{
  gotoScreen: (screen: Screens, chatId?: string | number) => void;
}>({ gotoScreen: (screen: Screens) => {} });
